import GradientText from 'components/gradient-text/GradientText'
import classes from './styles.module.css'
import {itManagementData} from 'content/home-page'
import clsx from 'clsx'
import Image from 'next/image'

export default function ITManagement() {
  return (
    <div className={classes.container} style={{background: itManagementData.bgColor}}>
      <div className={classes.subContainer}>
        <GradientText text={itManagementData.topTitle} type="secondary" />
        {/* <p className={classes.topTitle}> {itManagementData.topTitle}</p> */}
        <h2 className={clsx('header2', classes.header)}>
          {itManagementData.title}{' '}
          {itManagementData.titleVariant ? (
            <p style={{color: itManagementData.titleVariant.color}}>
              {itManagementData.titleVariant.text}
            </p>
          ) : (
            ''
          )}
        </h2>
        <div className={classes.cardContainer}>
          <div className={classes.firstSection}>
            <div className={classes.oldImgContainer}>
              <Image src={itManagementData.oldWays.imgSrc} alt="old" />
            </div>
            <h3 className={classes.oldTitle}>{itManagementData.oldWays.title}</h3>
            <ul className={classes.listContainer}>
              {itManagementData.oldWays.list.map(data => (
                <li className={classes.singleList} key={data}>
                  <div className={classes.listName}>
                    <Image
                      className={classes.listIcon}
                      src={itManagementData.oldWays.listIcon}
                      alt="old ways"
                      height={20}
                      width={20}
                    />
                  </div>
                  <p className={classes.oldListText}>{data}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className={classes.secondSection}>
            <div className={classes.topDetails}>
              {/* <div className={classes.newImgContainer}>
                <div className={classes.newImgSubContainer}> */}
                  <Image
                    className={classes.oldImage}
                    src={itManagementData.newWays.imgSrc}
                    alt="old"
                  />
                {/* </div>
              </div> */}
              <div className={classes.background}></div>
            </div>
            <h3 className={classes.newTitle}>{itManagementData.newWays.title}</h3>
            <ul className={classes.listContainer}>
              {itManagementData.newWays.list.map(data => (
                <li className={classes.singleList} key={data}>
                  <div className={classes.newListImageContainer}>
                    <Image
                      className={classes.listIcon}
                      src={itManagementData.newWays.listIcon}
                      alt="new ways"
                      height={20}
                      width={20}
                    />
                  </div>
                  <p className={classes.newWayText}>{data}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
